import type { Datacenter, DatacenterServer } from './types';

export const mockDatacenters: Datacenter[] = [
  {
    id: 'DC-001',
    name: '北京数据中心',
    code: 'BJ-DC-01',
    remoteId: 'remote-bj-001',
    connectionUrl: 'https://bj-dc-01.example.com',
    apiKey: 'bj_api_key_***',
    location: {
      province: '北京市',
      city: '北京市',
      district: '海淀区',
      address: '中关村软件园二期',
    },
    description: '北京主数据中心，提供高性能计算服务',
    type: 'self-built',
    bandwidth: '10Gbps',
    isp: '中国电信',
    buildDate: '2023-03-15',
    contact: {
      name: '张伟',
      phone: '13800138001',
    },
    status: 'normal',
    resources: {
      serverCount: 50,
      totalCpu: 3200,
      totalMemory: 12800,
      totalDisk: 200000,
      gpuStats: {
        t4: 80,
        rtx5070: 120,
        rtx5090_16g: 60,
        rtx5090_32g: 40,
      },
      instanceStats: {
        online: 450,
        total: 500,
      },
    },
    monitoring: {
      bandwidth: { used: 7.5, total: 10 },
      instanceOnlineRate: { rate: 90, online: 450, total: 500 },
      cpuUsage: { rate: 65, used: 2080, total: 3200 },
      gpuUsage: { rate: 72, used: 216, total: 300 },
      memoryUsage: { rate: 58, used: 7424, total: 12800 },
      diskUsage: { rate: 45, used: 90000, total: 200000 },
    },
  },
  {
    id: 'DC-002',
    name: '上海数据中心',
    code: 'SH-DC-01',
    remoteId: 'remote-sh-001',
    connectionUrl: 'https://sh-dc-01.example.com',
    apiKey: 'sh_api_key_***',
    location: {
      province: '上海市',
      city: '上海市',
      district: '浦东新区',
      address: '张江高科技园区',
    },
    description: '上海数据中心，服务华东地区',
    type: 'hosted',
    bandwidth: '20Gbps',
    isp: '中国联通',
    buildDate: '2023-06-20',
    contact: {
      name: '李娜',
      phone: '13800138002',
    },
    status: 'normal',
    resources: {
      serverCount: 80,
      totalCpu: 5120,
      totalMemory: 20480,
      totalDisk: 320000,
      gpuStats: {
        t4: 120,
        rtx5070: 200,
        rtx5090_16g: 100,
        rtx5090_32g: 80,
      },
      instanceStats: {
        online: 720,
        total: 800,
      },
    },
    monitoring: {
      bandwidth: { used: 15.5, total: 20 },
      instanceOnlineRate: { rate: 90, online: 720, total: 800 },
      cpuUsage: { rate: 70, used: 3584, total: 5120 },
      gpuUsage: { rate: 68, used: 340, total: 500 },
      memoryUsage: { rate: 62, used: 12698, total: 20480 },
      diskUsage: { rate: 52, used: 166400, total: 320000 },
    },
  },
  {
    id: 'DC-003',
    name: '深圳数据中心',
    code: 'SZ-DC-01',
    remoteId: 'remote-sz-001',
    connectionUrl: 'https://sz-dc-01.example.com',
    apiKey: 'sz_api_key_***',
    location: {
      province: '广东省',
      city: '深圳市',
      district: '南山区',
      address: '科技园南区',
    },
    description: '深圳数据中心，服务华南地区',
    type: 'rented',
    bandwidth: '15Gbps',
    isp: '中国移动',
    buildDate: '2023-09-10',
    contact: {
      name: '王芳',
      phone: '13800138003',
    },
    status: 'maintenance',
    resources: {
      serverCount: 60,
      totalCpu: 3840,
      totalMemory: 15360,
      totalDisk: 240000,
      gpuStats: {
        t4: 90,
        rtx5070: 150,
        rtx5090_16g: 80,
        rtx5090_32g: 60,
      },
      instanceStats: {
        online: 0,
        total: 600,
      },
    },
    monitoring: {
      bandwidth: { used: 0, total: 15 },
      instanceOnlineRate: { rate: 0, online: 0, total: 600 },
      cpuUsage: { rate: 0, used: 0, total: 3840 },
      gpuUsage: { rate: 0, used: 0, total: 380 },
      memoryUsage: { rate: 0, used: 0, total: 15360 },
      diskUsage: { rate: 48, used: 115200, total: 240000 },
    },
  },
];

export const mockDatacenterServers: DatacenterServer[] = [
  {
    id: 'SRV-001',
    name: '服务器-001',
    serverNumber: 'BJ-SRV-001',
    internalIp: '192.168.1.10',
    publicIp: '123.123.123.10',
    hardware: {
      cpu: 'Intel Xeon Gold 6248R (64核)',
      memory: '256GB',
      disk: '4TB SSD',
      gpu: '4x NVIDIA Tesla T4',
    },
    status: 'normal',
  },
  {
    id: 'SRV-002',
    name: '服务器-002',
    serverNumber: 'BJ-SRV-002',
    internalIp: '192.168.1.11',
    publicIp: '123.123.123.11',
    hardware: {
      cpu: 'AMD EPYC 7763 (96核)',
      memory: '512GB',
      disk: '8TB NVMe SSD',
      gpu: '8x NVIDIA RTX 5070',
    },
    status: 'normal',
  },
  {
    id: 'SRV-003',
    name: '服务器-003',
    serverNumber: 'BJ-SRV-003',
    internalIp: '192.168.1.12',
    publicIp: '123.123.123.12',
    hardware: {
      cpu: 'Intel Xeon Platinum 8358 (64核)',
      memory: '384GB',
      disk: '10TB NVMe SSD',
      gpu: '8x NVIDIA RTX 5090 16G',
    },
    status: 'normal',
  },
];
